export default class Locale_AlignContractMenu {
	AlignStatus: string = "Align status";
	ChangeStatus: string = "Change status";
	FailedChangingContractAlignment: string = "Failed changing contract align status!";
}